<template lang="pug">
AppGallery.hidden(
  v-if="show"
  ref="gallery"
  :gallery-options="{ dynamic: true }"
  @gallery-closed="$emit('hide-dialog')"
)
  AppGalleryItem.hidden(
    v-for="(screenshot, index) in screenshots"
    :key="screenshot.id"
    :url="screenshot.original_url"
    :thumb-url="screenshot.thumb_url"
    :caption="`Screenshot ${index + 1} of ${screenshots.length}`"
  )
</template>

<script>
import AppGallery from '~/components/AppGallery.vue';
import AppGalleryItem from '~/components/AppGalleryItem.vue';

export default {
  name: 'TimeEntriesScreensDialog',
  components: { AppGallery, AppGalleryItem },
  props: {
    screenshots: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$watch(
      'show',
      (show) => {
        if (!show || !this.$refs.gallery) {
          return;
        }

        this.$nextTick(() => {
          const gallery = this.$refs.gallery;

          if (this.show && gallery?.dynamicEl?.length) {
            gallery.openItemByIndex(0);
          }
        });
      },
      { flush: 'post' },
    );
  },
};
</script>
